import React from "react";
import Default from "@/Layouts/Default";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import { Link, animateScroll as scroll } from "react-scroll";

const quotes = [
    {
        name: "Weer met een lach in de spiegel kijken",
    },
    {
        name: "Met trots leuke kleding kunnen dragen",
    },
    {
        name: "Zonder schaamte over het strand lopen in zwemkleding",
    },
    {
        name: "Weer een fitte papa of mama voor je kinderen",
    },
    {
        name: "Meer zelfvertrouwen in jezelf en je figuur",
    },
    {
        name: "Geen ‘morgen-begin-ik-echt’ mentaliteit meer",
    },
    {
        name: "Geen jojo-effect meer maar duurzame resultaten",
    },
    {
        name: "Genieten van de spiegel en zelfverzekerd glimlachen",
    },
    {
        name: "De vrijheid om stijlvolle kleding met trots te dragen",
    },
    {
        name: "Stralend over het strand lopen zonder zorgen over je uiterlijk",
    },
];

const getItemsPerRow = () => {
    const width = window.innerWidth;
    if (width >= 1280) return 12; // xl
    if (width >= 1024) return 12; // lg
    if (width >= 768) return 12; // md
    if (width >= 640) return 12; // sm
    return 6; // xs
};

export default function Results() {
    return (
        <Default>
            <Head>
                <title>Resultaten</title>
                <link rel="canonical" href={route("results")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Hier vindt je een overzicht van mensen die bij ons een personal training traject hebben gevolgd. "
                />
                <meta
                    property="og:description"
                    content="Hier vindt je een overzicht van mensen die bij ons een personal training traject hebben gevolgd."
                />
                <meta property="og:url" content={route("results")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Resultaten - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                <div
                    className="relative xs:py-8 sm:py-8 md:py-16 lg:py-32"
                    id="physical-transformations"
                >
                    <h2 id="gallery-heading" className="sr-only">
                        Transformaties
                    </h2>
                    <div
                        role="list"
                        className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8"
                    >
                        {[...Array(119)].map((x, i) => (
                                <React.Fragment key={i}>
                                    <div className="relative ml-0 p-2 lg:px-4">
                                        <div
                                            className={
                                                "group block w-full aspect-w-10 aspect-h-10 rounded-lg bg-black"
                                            }
                                        >
                                            <picture>
                                                <source
                                                    srcSet={`/assets/transformations/webp/personal-training-uden-schijndel-${
                                                        1 + i
                                                    }.webp`}
                                                    width="960"
                                                    height="960"
                                                    type="image/webp"
                                                    alt={
                                                        "Transformatie " +
                                                        (1 + i)
                                                    }
                                                    className="object-cover pointer-events-none"
                                                />
                                                <source
                                                    srcSet={`/assets/transformations/personal-training-uden-schijndel-${
                                                        1 + i
                                                    }.jpg`}
                                                    width="960"
                                                    height="960"
                                                    type="image/jpeg"
                                                    alt={
                                                        "Transformatie " +
                                                        (1 + i)
                                                    }
                                                    className="object-cover pointer-events-none"
                                                />
                                                <img
                                                    src={`/assets/transformations/personal-training-uden-schijndel-${
                                                        1 + i
                                                    }.jpg`}
                                                    width="960"
                                                    height="960"
                                                    alt={
                                                        "Transformatie " +
                                                        (1 + i)
                                                    }
                                                    className="object-cover pointer-events-none"
                                                />
                                            </picture>
                                        </div>
                                    </div>
                                    {(i + 1) % getItemsPerRow() === 0 &&
                                        quotes[(i + 1) / getItemsPerRow()] && (
                                            <div
                                                key={`quote-${i}`}
                                                className="text-white text-center font-custom italic font-bold uppercase mx-auto col-span-full text-3xl xs:text-2xl sm:text-2xl"
                                            >
                                                "
                                                {
                                                    quotes[
                                                        (i + 1) /
                                                            getItemsPerRow()
                                                    ].name
                                                }
                                                "
                                            </div>
                                        )}
                                </React.Fragment>
                            ))}
                    </div>
                </div>

                <Contact />
            </div>
        </Default>
    );
}
